import { useTranslation } from "react-i18next";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import imageUrl from "utils/imageUrl";
import "../sidebar/sidebar.css";
import utils from "../../utils";
import { ADMIN_TYPES, SUB_ADMIN_TYPES } from "../../assets/constants";
import { useEffect } from "react";
import apis from "services";
import { CSVLink } from "react-csv";
import Link from "hooks/Link";
import {
  BlogSidebar,
  DashboardSidebar,
  DividendSidebar,
  ExportSidebar,
  NotificationHistorySidebar,
  ReferralSidebar,
  SendNotficationSidebar,
  SharePriceHistorySidebar,
  StoreSidebar,
  TicketIcon,
  TransactionHistorySidebar,
  ShareManagementSidebar,
  PopupManagementSidebar,
  UserDocSidebar,
  UserSidebar,
  WalletSidebar,
  WithdrawalSidebar,
} from "components/SVG/SIDEBARSVG";
import { useLocation } from "react-router-dom";

const AdminNewSidebar = () => {
  const location = useLocation();
  const pathWithoutLang = location.pathname.replace(/^\/(en|sp)/, "");
  console.log(
    "pathWithoutLangpathWithoutLang",
    pathWithoutLang.split("/admin")[1]
  );
  const isId = (segment) => /^[a-fA-F0-9]{24}$/.test(segment);
  const pathParts = pathWithoutLang.split("/");
  const cleanedPathParts = pathParts.filter((part) => !isId(part));

  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();

  const [newsData, setNewsData] = useState([]);

  const { adminUser } = useSelector((store) => store.admin);
  const fetchNewsFeet = async () => {
    const res = await apis.getAllNewsFeet();
    if (res?.data?.status) setNewsData(res?.data?.news);
  };
  useEffect(() => {
    (async () => {
      if (adminUser) {
        await fetchNewsFeet();
      }
    })();
  }, []);

  // const { user } = useSelector((store) => store.user);
  return (
    <>
      <div className={`sidebar custom-scroll ${isOpen ? "open" : ""}`}>
        <div className="logo-details logo-icon primary-logo">
          <div className="sb-icon-wrapper">
            <i className="bx bxl-c-plus-plus icon"></i>
          </div>
          <img src={imageUrl("logo-icon.png")} alt="" />
        </div>
        <div className="logo-details">
          <div className="sb-icon-wrapper">
            <i className="bx bxl-c-plus-plus icon"></i>
          </div>
          <img
            src={imageUrl("bars-icon.png")}
            alt=""
            id="btn"
            onClick={() => setIsOpen((prevState) => !prevState)}
          />
        </div>
        {}
        <div className={`sidebar-content-name-con ${!isOpen ? "hidden" : ""}`}>
          <h3>
            {cleanedPathParts.includes("admin")
              ? cleanedPathParts[cleanedPathParts.indexOf("admin") + 1]
              : cleanedPathParts.includes("sub-admin")
              ? cleanedPathParts[cleanedPathParts.indexOf("sub-admin") + 1]
              : null}
          </h3>
        </div>
        <ul className="nav-list">
          {adminUser ? (
            <>
              {SUB_ADMIN_TYPES.includes(adminUser?.type) ? (
                <>
                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="Dashboard"
                    className={
                      pathWithoutLang === "/sub-admin/dashboard"
                        ? "activeSidebar"
                        : ""
                    }
                  >
                    <Link to={"/sub-admin/dashboard"}>
                      <div className="sb-icon-wrapper">
                        <DashboardSidebar
                          color={
                            pathWithoutLang === "/sub-admin/dashboard"
                              ? "#000"
                              : "#fff"
                          }
                        />
                      </div>
                      <span className="links_name">
                        {t("titles.dashboard")}
                      </span>
                    </Link>
                  </li>
                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="Wallet"
                    className={
                      pathWithoutLang === "/sub-admin/wallet"
                        ? "activeSidebar"
                        : ""
                    }
                  >
                    <Link to={"/sub-admin/wallet"}>
                      <div className="sb-icon-wrapper">
                        <WalletSidebar
                          color={
                            pathWithoutLang === "/sub-admin/wallet"
                              ? "#000"
                              : "#fff"
                          }
                        />
                      </div>
                      <span className="links_name">{t("buttons.wallet")}</span>
                    </Link>
                  </li>
                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="Users"
                    className={
                      pathWithoutLang === "/sub-admin/users"
                        ? "activeSidebar"
                        : ""
                    }
                  >
                    <Link to={"/sub-admin/users"}>
                      <div className="sb-icon-wrapper">
                        <UserSidebar
                          color={
                            pathWithoutLang === "/sub-admin/users"
                              ? "#000"
                              : "#fff"
                          }
                        />
                      </div>
                      <span className="links_name">{t("buttons.users")}</span>
                    </Link>
                  </li>
                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="Stores"
                    className={
                      pathWithoutLang === "/sub-admin/stores"
                        ? "activeSidebar"
                        : ""
                    }
                  >
                    <Link to={"/sub-admin/stores"}>
                      <div className="sb-icon-wrapper">
                        <StoreSidebar
                          color={
                            pathWithoutLang === "/sub-admin/stores"
                              ? "#000"
                              : "#fff"
                          }
                        />
                      </div>
                      <span className="links_name">{t("buttons.stores")}</span>
                    </Link>
                  </li>
                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="Blog"
                    className={
                      pathWithoutLang === "/sub-admin/blog"
                        ? "activeSidebar"
                        : ""
                    }
                  >
                    <Link to={"/sub-admin/blog"}>
                      <div className="sb-icon-wrapper">
                        <BlogSidebar
                          color={
                            pathWithoutLang === "/sub-admin/blog"
                              ? "#000"
                              : "#fff"
                          }
                        />
                      </div>
                      <span className="links_name">{t("buttons.blog")}</span>
                    </Link>
                  </li>
                 
                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="withDrawl User"
                    className={
                      pathWithoutLang === "/sub-admin/withDrawl"
                        ? "activeSidebar"
                        : ""
                    }
                  >
                    <Link to={"/sub-admin/withDrawl"}>
                      <div className="sb-icon-wrapper">
                        <WithdrawalSidebar
                          color={
                            pathWithoutLang === "/sub-admin/withDrawl"
                              ? "#000"
                              : "#fff"
                          }
                        />
                      </div>
                      <span className="links_name">
                        {t("buttons.withDrawl")}
                      </span>
                    </Link>
                  </li>
                </>
              ) : (
                <></>
              )}
              {adminUser?.type === "owner" ? (
                <>
                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="Dashboard"
                    className={
                      pathWithoutLang === "/admin/dashboard"
                        ? "activeSidebar"
                        : ""
                    }
                  >
                    <Link to={"/admin/dashboard"}>
                      <div className="sb-icon-wrapper">
                        <DashboardSidebar
                          color={
                            pathWithoutLang === "/admin/dashboard"
                              ? "#000"
                              : "#fff"
                          }
                        />
                      </div>
                      <span className="links_name">
                        {t("titles.dashboard")}
                      </span>
                    </Link>
                  </li>
                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="Wallet"
                    className={
                      pathWithoutLang === "/admin/wallet" ? "activeSidebar" : ""
                    }
                  >
                    <Link to={"/admin/wallet"}>
                      <div className="sb-icon-wrapper">
                        <WalletSidebar
                          color={
                            pathWithoutLang === "/admin/wallet"
                              ? "#000"
                              : "#fff"
                          }
                        />
                      </div>
                      <span className="links_name">{t("buttons.wallet")}</span>
                    </Link>
                  </li>
                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="Users"
                    className={
                      pathWithoutLang === "/admin/users" ? "activeSidebar" : ""
                    }
                  >
                    <Link to={"/admin/users"}>
                      <div className="sb-icon-wrapper">
                        <UserSidebar
                          color={
                            pathWithoutLang === "/admin/users" ? "#000" : "#fff"
                          }
                        />
                      </div>
                      <span className="links_name">{t("buttons.users")}</span>
                    </Link>
                  </li>
                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="Users Document"
                    className={
                      pathWithoutLang === "/admin/users-document"
                        ? "activeSidebar"
                        : ""
                    }
                  >
                    <Link to={"/admin/users-document"}>
                      <div className="sb-icon-wrapper">
                        <UserDocSidebar
                          color={
                            pathWithoutLang === "/admin/users-document"
                              ? "#000"
                              : "#fff"
                          }
                        />
                      </div>
                      <span className="links_name">
                        {t("buttons.document")}
                      </span>
                    </Link>
                  </li>
                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="Share Management"
                    className={
                      pathWithoutLang === "/admin/share-management"
                        ? "activeSidebar"
                        : ""
                    }
                  >
                    <Link to={"/admin/share-management"}>
                      <div className="sb-icon-wrapper">
                        <ShareManagementSidebar
                          color={
                            pathWithoutLang === "/admin/share-management"
                              ? "#000"
                              : "#fff"
                          }
                        />
                      </div>
                      <span className="links_name">
                        {t("buttons.share-management")}
                      </span>
                    </Link>
                  </li>

                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="Annual Progress"
                    className={
                      pathWithoutLang === "/admin/annual-progress"
                        ? "activeSidebar"
                        : ""
                    }
                  >
                    <Link to={"/admin/annual-progress"}>
                      <div className="sb-icon-wrapper">
                        <UserDocSidebar
                          color={
                            pathWithoutLang === "/admin/annual-progress"
                              ? "#000"
                              : "#fff"
                          }
                        />
                      </div>
                      <span className="links_name">
                        {t("buttons.annual-progress")}
                      </span>
                    </Link>
                  </li>

                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="Stores"
                    className={
                      pathWithoutLang === "/admin/stores" ? "activeSidebar" : ""
                    }
                  >
                    <Link to={"/admin/stores"}>
                      <div className="sb-icon-wrapper">
                        <StoreSidebar
                          color={
                            pathWithoutLang === "/admin/stores"
                              ? "#000"
                              : "#fff"
                          }
                        />
                      </div>
                      <span className="links_name">{t("buttons.stores")}</span>
                    </Link>
                  </li>
                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="Transactions"
                    className={
                      pathWithoutLang === "/admin/transactions"
                        ? "activeSidebar"
                        : ""
                    }
                  >
                    <Link to={"/admin/transactions"}>
                      <div className="sb-icon-wrapper">
                        <TransactionHistorySidebar
                          color={
                            pathWithoutLang === "/admin/transactions"
                              ? "#000"
                              : "#fff"
                          }
                        />
                      </div>
                      <span className="links_name">
                        {t("buttons.transactions")}
                      </span>
                    </Link>
                  </li>
                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="Transactions"
                    className={
                      pathWithoutLang === "/admin/admin-transactions"
                        ? "activeSidebar"
                        : ""
                    }
                  >
                    <Link to={"/admin/admin-transactions"}>
                      <div className="sb-icon-wrapper">
                        <TransactionHistorySidebar
                          color={
                            pathWithoutLang === "/admin/admin-transactions"
                              ? "#000"
                              : "#fff"
                          }
                        />
                      </div>
                      <span className="links_name">
                        {t("buttons.admin-transactions")}
                      </span>
                    </Link>
                  </li>
                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="Transactions Offers"
                    className={
                      pathWithoutLang === "/admin/transactions-offers"
                        ? "activeSidebar"
                        : ""
                    }
                  >
                    <Link to={"/admin/transactions-offers"}>
                      <div className="sb-icon-wrapper">
                        <TransactionHistorySidebar
                          color={
                            pathWithoutLang === "/admin/transactions-offers"
                              ? "#000"
                              : "#fff"
                          }
                        />
                      </div>
                      <span className="links_name">
                        {t("titles.transactionsOffers")}
                      </span>
                    </Link>
                  </li>
                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="Offers"
                    className={
                      pathWithoutLang === "/admin/offers" ? "activeSidebar" : ""
                    }
                  >
                    <Link to={"/admin/offers"}>
                      <div className="sb-icon-wrapper">
                        <TransactionHistorySidebar
                          color={
                            pathWithoutLang === "/admin/offers"
                              ? "#000"
                              : "#fff"
                          }
                        />
                      </div>
                      <span className="links_name">{t("titles.offers")}</span>
                    </Link>
                  </li>
                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="Send Notifications"
                    className={
                      pathWithoutLang === "/admin/send-notification"
                        ? "activeSidebar"
                        : ""
                    }
                  >
                    <Link to={"/admin/send-notification"}>
                      <div className="sb-icon-wrapper">
                        <SendNotficationSidebar
                          color={
                            pathWithoutLang === "/admin/send-notification"
                              ? "#000"
                              : "#fff"
                          }
                        />
                      </div>
                      <span className="links_name">
                        {t("buttons.send_notifications")}
                      </span>
                    </Link>
                  </li>
                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="Notification History"
                    className={
                      pathWithoutLang === "/admin/notification-history"
                        ? "activeSidebar"
                        : ""
                    }
                  >
                    <Link to={"/admin/notification-history"}>
                      <div className="sb-icon-wrapper">
                        <NotificationHistorySidebar
                          color={
                            pathWithoutLang === "/admin/notification-history"
                              ? "#000"
                              : "#fff"
                          }
                        />
                      </div>
                      <span className="links_name">
                        {t("buttons.notifications_history")}
                      </span>
                    </Link>
                  </li>
                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="Share Price History"
                    className={
                      pathWithoutLang === "/admin/share-price-history"
                        ? "activeSidebar"
                        : ""
                    }
                  >
                    <Link to={"/admin/share-price-history"}>
                      <div className="sb-icon-wrapper">
                        <SharePriceHistorySidebar
                          color={
                            pathWithoutLang === "/admin/share-price-history"
                              ? "#000"
                              : "#fff"
                          }
                        />
                      </div>
                      <span className="links_name">
                        {t("buttons.share_price_history")}
                      </span>
                    </Link>
                  </li>
                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="Referral History"
                    className={
                      pathWithoutLang === "/admin/referral-history"
                        ? "activeSidebar"
                        : ""
                    }
                  >
                    <Link to={"/admin/referral-history"}>
                      <div className="sb-icon-wrapper">
                        <ReferralSidebar
                          color={
                            pathWithoutLang === "/admin/referral-history"
                              ? "#000"
                              : "#fff"
                          }
                        />
                      </div>
                      <span className="links_name">{t("titles.referral")}</span>
                    </Link>
                  </li>
                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="Dividend"
                    className={
                      pathWithoutLang === "/admin/dividend"
                        ? "activeSidebar"
                        : ""
                    }
                  >
                    <Link to={"/admin/dividend"}>
                      <div className="sb-icon-wrapper">
                        <DividendSidebar
                          color={
                            pathWithoutLang === "/admin/dividend"
                              ? "#000"
                              : "#fff"
                          }
                        />
                      </div>
                      <span className="links_name">
                        {t("buttons.dividend")}
                      </span>
                    </Link>
                  </li>

                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="Divident History"
                    className={
                      pathWithoutLang === "/admin/dividend-history"
                        ? "activeSidebar"
                        : ""
                    }
                  >
                    <Link to={"/admin/dividend-history"}>
                      <div className="sb-icon-wrapper">
                        <DividendSidebar
                          color={
                            pathWithoutLang === "/admin/dividend-history"
                              ? "#000"
                              : "#fff"
                          }
                        />
                      </div>
                      <span className="links_name">
                        {t("buttons.dividendHistory")}
                      </span>
                    </Link>
                  </li>
                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="Share Transfer"
                    className={
                      pathWithoutLang === "/admin/share-transfer"
                        ? "activeSidebar"
                        : ""
                    }
                  >
                    <Link to={"/admin/share-transfer"}>
                      <div className="sb-icon-wrapper">
                        <DividendSidebar
                          color={
                            pathWithoutLang === "/admin/share-transfer"
                              ? "#000"
                              : "#fff"
                          }
                        />
                      </div>
                      <span className="links_name">
                        {t("buttons.shareTransfer")}
                      </span>
                    </Link>
                  </li>

                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="Share Transfer History"
                    className={
                      pathWithoutLang === "/admin/share-transfer-history"
                        ? "activeSidebar"
                        : ""
                    }
                  >
                    <Link to={"/admin/share-transfer-history"}>
                      <div className="sb-icon-wrapper">
                        <DividendSidebar
                          color={
                            pathWithoutLang === "/admin/share-transfer-history"
                              ? "#000"
                              : "#fff"
                          }
                        />
                      </div>
                      <span className="links_name">
                        {t("buttons.shareTransferHistory")}
                      </span>
                    </Link>
                  </li>
                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="Token Transfer"
                    className={
                      pathWithoutLang === "/admin/token-transfer"
                        ? "activeSidebar"
                        : ""
                    }
                  >
                    <Link to={"/admin/token-transfer"}>
                      <div className="sb-icon-wrapper">
                        <TransactionHistorySidebar
                          color={
                            pathWithoutLang === "/admin/token-transfer"
                              ? "#000"
                              : "#fff"
                          }
                        />
                      </div>
                      <span className="links_name">
                        {t("buttons.jtcTokenTransfer")}
                      </span>
                    </Link>
                  </li>

                  {/* "work Done By Mohsin" */}
                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="Share Transfer History"
                    className={
                      pathWithoutLang === "/admin/token-transfer-history"
                        ? "activeSidebar"
                        : ""
                    }
                  >
                    <Link to={"/admin/token-transfer-history"}>
                      <div className="sb-icon-wrapper">
                        <TransactionHistorySidebar
                          color={
                            pathWithoutLang === "/admin/token-transfer-history"
                              ? "#000"
                              : "#fff"
                          }
                        />
                      </div>
                      <span className="links_name">
                        {t("buttons.jtcTokenTransferHistory")}
                      </span>
                    </Link>
                  </li>

                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="Blog"
                    className={
                      pathWithoutLang === "/admin/blog" ? "activeSidebar" : ""
                    }
                  >
                    <Link to={"/admin/blog"}>
                      <div className="sb-icon-wrapper">
                        <BlogSidebar
                          color={
                            pathWithoutLang === "/admin/blog" ? "#000" : "#fff"
                          }
                        />
                      </div>
                      <span className="links_name">{t("buttons.blog")}</span>
                    </Link>
                  </li>
                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="Popup- Settings"
                    className={
                      pathWithoutLang === "admin/popup-management"
                        ? "activeSidebar"
                        : ""
                    }
                  >
                    <Link to={"/admin/popup-management"}>
                      <div className="sb-icon-wrapper">
                        <PopupManagementSidebar
                          color={
                            pathWithoutLang === "/admin/popup-management"
                              ? "#000"
                              : "#fff"
                          }
                        />
                      </div>
                      <span className="links_name">{t("buttons.popup")}</span>
                    </Link>
                  </li>
                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="withDrawl User"
                    className={
                      pathWithoutLang === "/admin/withDrawl"
                        ? "activeSidebar"
                        : ""
                    }
                  >
                    <Link to={"/admin/withDrawl"}>
                      <div className="sb-icon-wrapper">
                        <WithdrawalSidebar
                          color={
                            pathWithoutLang === "/admin/withDrawl"
                              ? "#000"
                              : "#fff"
                          }
                        />
                      </div>
                      <span className="links_name">
                        {t("buttons.withDrawl-user")}
                      </span>
                    </Link>
                  </li>
                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="withDrawl Admin"
                    className={
                      pathWithoutLang === "/admin/withDrawl-request"
                        ? "activeSidebar"
                        : ""
                    }
                  >
                    <Link to={"/admin/withDrawl-request"}>
                      <div className="sb-icon-wrapper">
                        <WithdrawalSidebar
                          color={
                            pathWithoutLang === "/admin/withDrawl-request"
                              ? "#000"
                              : "#fff"
                          }
                        />
                      </div>
                      <span className="links_name">
                        {t("buttons.withDrawl-admin")}
                      </span>
                    </Link>
                  </li>
                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="Export"
                  >
                    <CSVLink
                      onClick={() => {
                        console.table(newsData);
                      }}
                      style={{ color: "blue" }}
                      data={newsData}
                    >
                      <div className="sb-icon-wrapper">
                        <ExportSidebar color={"#fff"} />
                      </div>
                      <span className="links_name">Export</span>
                    </CSVLink>
                  </li>
                  <li
                    data-bs-toggle="tooltip"
                    data-bs-custom-class="custom-tooltip"
                    data-bs-placement="right"
                    title="tickets"
                    className={
                      pathWithoutLang === "/admin/tickets/manage-all"
                        ? "activeSidebar"
                        : ""
                    }
                  >
                    <Link to={"/admin/tickets/manage-all"}>
                      <div className="sb-icon-wrapper">
                        <TicketIcon
                          color={
                            pathWithoutLang === "/admin/tickets/manage-all"
                              ? "#000"
                              : "#fff"
                          }
                        />
                      </div>
                      <span className="links_name">
                        {t("buttons.tickets")}
                      </span>
                    </Link>
                  </li>
                </>
              ) : (
                <></>
              )}
            </>
          ) : (
            <>
              <li
                data-bs-toggle="tooltip"
                data-bs-custom-class="custom-tooltip"
                data-bs-placement="right"
                title="Dashboard"
              >
                <Link to={"/user/dashboard"}>
                  <div className="sb-icon-wrapper">
                    <img
                      src={imageUrl("dash_icon.png")}
                      alt=""
                      loading="lazy"
                    />
                  </div>
                  <span className="links_name">
                    {t("new-changes.admin_dashboard")}
                  </span>
                </Link>
              </li>
              <li
                data-bs-toggle="tooltip"
                data-bs-custom-class="custom-tooltip"
                data-bs-placement="right"
                title="Wallet"
              >
                <Link to={"/user/wallet"}>
                  <div className="sb-icon-wrapper">
                    <img
                      src={imageUrl("wallet_icon.png")}
                      alt=""
                      loading="lazy"
                    />
                  </div>
                  <span className="links_name">{t("buttons.wallet")}</span>
                </Link>
              </li>
              <li
                data-bs-toggle="tooltip"
                data-bs-custom-class="custom-tooltip"
                data-bs-placement="right"
                title="Invest Now"
              >
                <Link to={"/franchise"}>
                  <div className="sb-icon-wrapper">
                    <img
                      src={imageUrl("dollar-icon.png")}
                      alt=""
                      loading="lazy"
                    />
                  </div>
                  <span className="links_name">{t("buttons.invest_now")}</span>
                </Link>
              </li>
              <li
                data-bs-toggle="tooltip"
                data-bs-custom-class="custom-tooltip"
                data-bs-placement="right"
                title="
                Withdrawal"
              >
                <Link to={"/user/withdrawl"}>
                  <div className="sb-icon-wrapper">
                    <img src={imageUrl("transaction_icon.png")} alt="" />
                  </div>
                  <span className="links_name">{t("buttons.withDrawl")}</span>
                </Link>
              </li>
              <li
                data-bs-toggle="tooltip"
                data-bs-custom-class="custom-tooltip"
                data-bs-placement="right"
                title="document"
              >
                <Link to={"/user/document"}>
                  <div className="sb-icon-wrapper">
                    <img
                      src={imageUrl("document_icon.png")}
                      alt=""
                      loading="lazy"
                    />
                  </div>
                  <span className="links_name">{t("buttons.document")}</span>
                </Link>
              </li>
              <li
                data-bs-toggle="tooltip"
                data-bs-custom-class="custom-tooltip"
                data-bs-placement="right"
                title="Referral"
              >
                <Link to={"/user/referral"}>
                  <div className="sb-icon-wrapper">
                    <img
                      src={imageUrl("rocket-icon.png")}
                      alt=""
                      loading="lazy"
                    />
                  </div>
                  <span className="links_name"> {t("titles.referral")}</span>
                </Link>
              </li>
            </>
          )}
        </ul>
      </div>
    </>
  );
};

export default AdminNewSidebar;
